// @ts-check
const LoadingScreen = () => {
  return (
    <div className="flex items-center justify-center py-20">
      <h1 className="animate-shimmer" style={{ fontSize: '44.7px', letterSpacing: '0.454em', fontWeight: '700' }}>
        KAAY
      </h1>

      <style>{`
        @keyframes shimmer {
          0% { opacity: 0.5; }
          50% { opacity: 1; }
          100% { opacity: 0.5; }
        }
        .animate-shimmer {
          animation: shimmer 2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;
